// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../../../config/screen';

// Components
import { Col } from '../../../../../../../../layout/elements/Col';
import { Row } from '../../../../../../../../layout/elements/Row';

export const ListContainer = styled(Row)`
  width: 100%;
  padding-bottom: 2rem;

  @media (min-width: ${BREAKPOINTS.lg}px) {
    row-gap: 24px;
  };
`;

export const ListCol = styled(Col)`
  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-right: 1.5rem;

    &:nth-child(2n) {
      padding-right: 0;
    };
  };
`;

export const Container = styled.div`
  margin-bottom: 2rem;
  height: 100%;
`;
